export default "__VITE_ASSET__Dx_9gGyf__"